import { render, staticRenderFns } from "./ProductChannel.vue?vue&type=template&id=7bb835d0&scoped=true"
import script from "./ProductChannel.vue?vue&type=script&lang=js"
export * from "./ProductChannel.vue?vue&type=script&lang=js"
import style0 from "./ProductChannel.vue?vue&type=style&index=0&id=7bb835d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb835d0",
  null
  
)

export default component.exports